import { Sparkles, ArrowRight } from "lucide-react";
import PlayerInterestDialog from "@/components/site/PlayerInterestDialog";
import { SPONSORSHIP } from "@/constants/testIds";

export default function SponsorshipStrip() {
  return (
    <section
      data-testid={SPONSORSHIP.section}
      className="relative bg-[#0A1128] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 lg:py-12 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
        <div className="flex items-center gap-4 flex-1">
          <div className="w-11 h-11 grid place-items-center border border-white/25 text-white flex-shrink-0">
            <Sparkles size={18} />
          </div>
          <div>
            <div className="text-[10px] tracking-[0.28em] uppercase text-[#93A5C0]">
              Now Available
            </div>
            <div className="font-display text-xl sm:text-2xl mt-1 tracking-tight">
              Full Player Sponsorship Opportunities
            </div>
            <div className="text-[#A0ABC0] text-sm mt-1 max-w-xl">
              Select players may qualify for full sponsorship. Reach out
              privately to Coach Bledsoe to learn more.
            </div>
          </div>
        </div>
        <PlayerInterestDialog
          testId={SPONSORSHIP.ctaTrigger}
          trigger={
            <button
              type="button"
              className="btn-ghost-gold inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm uppercase whitespace-nowrap"
            >
              Inquire About Sponsorship <ArrowRight size={15} />
            </button>
          }
        />
      </div>
    </section>
  );
}
